$(function(){
	$('.submenu--open,.submenu--close').on('click',function(){
		$('.page--title .mod_navigation').toggleClass('active');
	})


  $('.sublist_toggle').unbind("click").bind('click', function(){
    // $(this).toggleClass('hidden');
    $(this).closest('.event.layout_teaser').children('.sublist_seances').toggleClass('hidden');
  });
});



// check form's validity, return an object containing the result's status and use renderError() to display error messages
// params:
// jquery object container = form's container (don't need to be a form html mark up)
// NB:
// - to work properly, the container needs to have only one css class and contain a div.error-container.
// - only inputs with a required html attribute will be checked.
// - specials rules can be added to inputs (example: myInput_1 can be required if myInput_2 is filled).
//   In order to do this, the input need to have a "data-required" attribute, filled like this: "nameInputReferent/valueInputReferent/optionalLogicalOperator".
//   optionalLogicalOperator can be "and", "or", "xor". By default, the logical operator used is "and".
app.checkFormValidity = function checkFormValidity(container) {
    // var formInputs = $(container).find('input,textarea,select').filter('[name]');
    var formInputs = $(container).find('input,textarea,select').filter(function(i){return this.name != "";});
    var specialInputs = new Object();
    var results = new Object();
    results.valid = true;
    results.inputs = new Object();

    var arrNames = [];
    var arrTemp = formInputs.filter(function(i,el){
        if (arrNames.indexOf(el.name) == -1){
            arrNames.push(el.name);
            return el;          
        }
    });

    $.each(formInputs, function(index, input){
        var valid = true;
        var inputRow;
        switch(input.nodeName) {
          case 'SELECT':
          case 'TEXTAREA':
          case 'INPUT':
            if($(input).val() == '' && $(input).attr('required'))
              valid = false;
            break;
          default: break;
        }
        if ($(input).attr('name') === undefined)
          return false;
        inputRow = {
          'name' : $(input).attr('name').replace('[]', ''),
          'type' : input.nodeName,
          'value' : $(input).val(),
          'valid' : valid
        };

        if($(input).is(':invalid')) // regular check if inout is invalid, then result is false by default
            inputRow['valid'] = false;

        // CHECKBOXES
        if ($(input).attr('type') == 'checkbox') {
            inputRow.valid = true;
            if ($(container).find('input').filter('[name="'+$(input).attr('name')+'"]').length > 1) { // multiple checkbox, should return array of values
                inputRow.value = [];
                $(container).find('input').filter('[name="'+$(input).attr('name')+'"]').each(function(){
                    if ($(this).isChecked())
                        inputRow.value.push(this.value);
                });
                if ($(input).attr('required') && !inputRow.value.length)
                    inputRow.valid = false;
            } else { // unique checkbox, should return 1 or 0
                inputRow.value = ($(input).isChecked()) ? 1 : 0;
                if ($(input).attr('required') && inputRow.value == 0)
                    inputRow.valid = false;
            }
        }

        // RADIOS
        if ($(input).attr('type') == 'radio') {
            inputRow.valid = true;
            inputRow.value = false;
            $(container).find('input').filter('[name="'+$(input).attr('name')+'"]').each(function(){
                if ($(this).isChecked())
                    inputRow.value = (this.value);
            });
            if ($(input).attr('required') && !inputRow.value)
                inputRow.valid = false;
        }

        // DATEPICKERS
        if($(input).hasClass('datepicker'))
          inputRow.value = $(input).attr('data-tstamp');

        // WIZARDS
        if($(input).hasClass('wizard')){
          var fields = $(container).find('[data-wizard="'+inputRow.name+'"]');
          inputRow.value={};
          fields.each(function(i,group){
            if($(this).find('input.key').length && $(this).find('input.value').length){
              if ($(this).find('input.key').val() != "")
                inputRow.value[$(this).find('input.key').val()] = $(this).find('input.value').val();
            } else {
              inputRow.value[i] = {};
              $(this).find('input,select').each(function(){
                if ($(this).attr('data-wizardKey')){
                  app.renderError(input.name.replace('[]', '')+'_'+$(this).attr('data-wizardKey').replace('[]',''), $(container).attr('class'),false);
                  inputRow.value[i][$(this).attr('data-wizardKey')] = $(this).val();
                  if($(this).val() == '' && $(this).attr('required')){
                    console.log('invalid wizard');
                    var labelError = input.name.replace('[]', '');
                    if($(container).find('label[for*="'+input.name.replace('[]', '')+'"]').first().length)
                      labelError = '"'+ $(container).find('label[for*="'+input.name.replace('[]', '')+'"]').first().html().replace(':','').trim() + '"';
                    app.renderError(input.name.replace('[]', '')+'_'+$(this).attr('data-wizardKey').replace('[]',''), $(container).attr('class'), 'Le champ '+labelError+' ('+$(this).attr('data-wizardKey')+') est invalide ou incomplet.');
                  }
                }
              })
            }
          })
        }
        
        // FORM VALIDATION
        if($(input).attr('required') && !$(input).hasClass('nofill')){  // regular required input
          if(!inputRow['valid'])
            results.valid = false;
          results.inputs[inputRow.name] = inputRow;
        }
        else if($(input).attr('data-required') && !$(input).hasClass('nofill')){ // required input according to another input (aka "special inputs")
          var params = $(input).attr('data-required').split('/');
          requiredParams = {
            'inputName' : params[0],
            'inputValue' : params[1],
            'operator' : params[2]
          };
          if(!specialInputs[requiredParams.inputName]) {
            specialInputs[requiredParams.inputName] = new Object();
            specialInputs[requiredParams.inputName].params = requiredParams;
            specialInputs[requiredParams.inputName].inputs = [];
            specialInputs[requiredParams.inputName].inputs[inputRow.name] = inputRow;
          } else {
            specialInputs[requiredParams.inputName].inputs[inputRow.name] = inputRow;
          }
        } else { // input not required
          results.inputs[inputRow.name] = inputRow;
        }
    });

    // console.log(results);

    if(Object.keys(specialInputs).length > 0){  // do this if we have special inputs registred
        $.each(specialInputs, function(index, mode){
          var refInput;
          for(var i = 0; i < formInputs.length; i++) {
            if(formInputs[i].className === mode.params.inputName)
              refInput = formInputs[i];
          }
          var refInputValue = $(refInput).val();
          if(refInputValue == mode.params.inputValue) {
            var arrayCheck = [];
             $.each(mode.inputs, function(index, input){
                if(!input.valid)
                    arrayCheck.push(0);
                else
                    arrayCheck.push(1);
                results.inputs.push(input);
            });
            switch(mode.params.operator) {
              case 'or':
                if(arrayCheck.indexOf(1) == -1)
                    results.valid = false;
                break;
              case 'xor':
                var indexes = [], i = -1;
                while ((i = arrayCheck.indexOf(1, i+1)) != -1){
                    indexes.push(i);
                }
                if(indexes.length != 1)
                    results.valid = false;
                break;
              case 'and':
              default:
                $.each(mode.inputs, function(index, input){
                    if(!input.valid)
                        results.valid = false;
                    results.inputs.push(input);
                });
                break;
            }
          }
        });
    }
    if(!results.valid && $(container).find('.error-container').first()){  // display errors - the container need to have a div.error-container
      $.each(formInputs, function(index, input){
        app.renderError(input.name.replace('[]', ''), $(container).attr('class'), false); // clean all error messages
      });
      $.each(results.inputs, function(index, input){
        var labelError = input.name.replace('[]', '');
          // console.log(input.name,$(container).find('label[for="'+input.name.replace('[]', '')+'"]').first().length);
        if($(container).find('[name="'+input.name+'"]').length == 1){
	        if($(container).find('[name="'+input.name+'"]').attr('placeholder') !== "")
	        	labelError = $(container).find('[name="'+input.name+'"]').attr('placeholder');

	        if($(container).find('label[for*="'+input.name.replace('[]', '')+'"]').first().length) // if exist, get label of the input
	          labelError = '"'+ $(container).find('label[for*="'+input.name.replace('[]', '')+'"]').first().html().replace(':','').trim() + '"';
        } else {
        	if($(container).find('[name="'+input.name+'"]').parent().find('label').not('[for]').length)
        		labelError = $(container).find('[name="'+input.name+'"]').first().parent().find('label').not('[for]').text();
        }
        

        if(!input.valid){
          app.renderError(input.name.replace('[]', ''), $(container).attr('class'), 'Veuillez remplir le champ '+ labelError);
        }
        else
          app.renderError(input.name.replace('[]', ''), $(container).attr('class'), false);
      });
    }
    else if($(container).find('.error-container').first()){ // form is valid, clean all error messages
      $.each(formInputs, function(index, input){
          app.renderError(input.name.replace('[]', ''), $(container).attr('class'), false);
      });
    }
    return results; // return the global results
}


// display error message in specified container
// params:
// string selector = error's name
// string parent = id of the error's container
// string msg = error's message. take false as value to delete the message
// bool success = if true, the message displayed is a success message. default state is false
app.renderError = function renderError(selector, parent, msg, success)
{
    // DEBUG
    // console.log(selector)
    // console.log(parent)
    // console.log(msg)
    // console.log(success)
    // console.log('----------------------------------')
    if($('#'+parent+' .error-container').length === 0 && msg !== false) {
        if( typeof success !== 'undefined' && success == true)
            notif_fade.success(msg);
        else
            notif_fade.error(msg);
    }
    else {
        var selectors = selector.replace(' ','.');
        if( typeof success !== 'undefined' && success == true)
            selector = selector + ' confirm';
        $('#'+parent+' .error-container blockquote.'+selectors).fadeOut().remove();
        if(msg) {
            $('#'+parent+' .error-container').append('<blockquote class="'+selector+'"><p>'+msg+'</p></blockquote>');
            $('#'+parent+' .error-container blockquote.'+selectors).hide().fadeIn();
            if ($('#'+parent).closest('.modalFW').length) {
              $('#'+parent).closest('.modalFW').animate({
                  scrollTop: $('#'+parent+' .error-container').offset().top - 200
              }, 500);
            } else{
              $('html,body').animate({
                  scrollTop: $('#'+parent+' .error-container').offset().top - 200
              }, 500);
            }
        }
    }
}






// WEBPACK FOOTER //
// ./src/themes/mdfl/mdfl.js